import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { majorClient } from '../client/majorClient';


export type Params = {
  id: number;
};

type Options = {

};

const defaultOptions: Partial<Options> = {
};

export const useMajor = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: major } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getMajor, params.id],
    queryFn: () => majorClient.getMajor(params),
  });

  return {
    ...rest,
    major,
  };
};
